import React from 'react';
import styles from "./NoResults.module.sass";
import { useGlobalValue } from "../../state/GlobalProvider";
const NoResults = () => {
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("div", {
    className: styles["noresults-container"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["noresults-icons"]
  }, /*#__PURE__*/React.createElement("svg", {
    className: styles["noresults-icon"],
    xmlns: "http://www.w3.org/2000/svg",
    width: "78",
    height: "78",
    viewBox: "0 0 78 78",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.375 45.5H47.775L46.8 44.525C50.05 40.95 52 36.075 52 30.875C52 19.175 42.575 9.75 30.875 9.75C19.175 9.75 9.75 19.175 9.75 30.875C9.75 42.575 19.175 52 30.875 52C36.075 52 40.95 50.05 44.525 46.8L45.5 47.775V50.375L61.75 66.625L66.625 61.75L50.375 45.5ZM30.875 45.5C22.75 45.5 16.25 39 16.25 30.875C16.25 22.75 22.75 16.25 30.875 16.25C39 16.25 45.5 22.75 45.5 30.875C45.5 39 39 45.5 30.875 45.5Z",
    fill: "#072448"
  })), /*#__PURE__*/React.createElement("svg", {
    className: styles["noresults-icon-background"],
    xmlns: "http://www.w3.org/2000/svg",
    width: "77",
    height: "65",
    viewBox: "0 0 77 65",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 44.5C77.0001 61.9552 67.5411 65 41.1429 65C14.7446 65 0 50.8497 0 33.3945C0 15.9393 3.24878 0 29.6471 0C56.0453 0 77.0001 27.0448 77.0001 44.5Z",
    fill: "#015FFF",
    "fill-opacity": "0.3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles["noresults-text"]
  }, /*#__PURE__*/React.createElement("h5", null, i18n`no_results`), /*#__PURE__*/React.createElement("p", null, i18n`no_results_description`)));
};
export default NoResults;